module.exports = __webpack_public_path__ + "static/media/money-pounds-fifty.a9daf6ec.svg";